// Class base component using arrow function

// import React, { Component } from 'react'

// class Suresh extends Component {
//   render() {
//     return (
//       <div>
//         It is a class base component
//       </div>
//     )
//   }
// }

// export default Suresh




// const Suresh = () => {

//   return (
//     <>
//       <h1>
//          It is a function base component
//       </h1>    
//     </>

//   )
// }


// export default Suresh





// Function Base Component

// function Suresh (){

//   return (
//     <>
//     <h1>
//       It is a function base component
//     </h1>
//     </>
//   )

// }

// export default Suresh

import React from 'react'

export default function Suresh() {
  return (
    <div className='container d-flex justify-content-center align-items-center full-height'>
      <h1>
        Suresh Store
      </h1>
    </div>
  )
}